import React from 'react'
import PageHeader from '../../components/ui/PageHeader'

const ViewAgents = () => {
  return (
    <div>
        <PageHeader title={"Agents Details"} text={"Home/ Agents/ Agent Details"} />
    </div>
  )
}

export default ViewAgents